module.exports = __webpack_public_path__ + "static/media/UniversityofVermont.6c347651.png";